module.exports = __webpack_public_path__ + "img/star2green.dbf6ba8d.png";